import { createVanIconComponent } from "./van"

const EyeOutlined = createVanIconComponent("eye-o")
export default EyeOutlined
